import * as fromCart from '@mkp/cart/state';
import * as fromRouter from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import * as fromProductOptions from '@mkp/product-options/state';
import { fromUser } from '@mkp/user/state-logged-in/selectors';
import { fromSettings } from '@mkp/core/state';

export interface State {
  routerReducer: fromRouter.RouterReducerState;
  [fromSettings.featureKey]: fromSettings.State;
  [fromUser.featureKey]?: fromUser.State;
  [fromProductOptions.featureKey]?: fromProductOptions.State;
  cartState?: fromCart.CartState;
}

export const reducers: ActionReducerMap<State> = {
  routerReducer: fromRouter.routerReducer,
  [fromSettings.featureKey]: fromSettings.reducer,
};
